import { useState, useEffect } from 'react';

export const useOnLoadImagesIframes = (ref) => {
  const [status, setStatus] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const els = ref.current.querySelectorAll("img[src], iframe");
    const loadedEls = [];

    const updateStatus = (el) => {
      loadedEls.push(el);

      setStatus(loadedEls.length == els.length);
    };

    if (els.length === 0) {
      setStatus(true);
      return;
    }

    els.forEach((el, i) => {
      el.addEventListener("load", () => updateStatus(el, i), {
        once: true
      });
      el.addEventListener("error", () => updateStatus(el, i), {
        once: true
      });
    });

    return;
  }, [ref]);
console.log('status', status);

  return status;
};
